const COMMUNITIES_LAYERS = {
  risk: {
    property: 'PV_RISK',
    label: 'Risk',
    stops: [
      { to: 0.03, label: '0 - 0.03', color: '#95C1DD' },
      { to: 0.06, label: '0.03 - 0.06', color: '#D5EED2' },
      { to: 0.1, label: '0.06 - 0.1', color: '#FFFFDF' },
      { to: 0.15, label: '0.1 - 0.15', color: '#FED7B0' },
      { to: Infinity, label: '0.15 - 0.3', color: '#EB8C8E' },
    ],
  },
  vulnerability: {
    property: 'VULN_IDX',
    label: 'Vulnerability',
    stops: [
      { to: 0.3, label: '< 0.3', color: '#FFFAF5' },
      { to: 0.35, label: '0.3 - 0.35', color: '#FEE8D2' },
      { to: 0.4, label: '0.35 - 0.4', color: '#FEC8A1' },
      { to: 0.5, label: '0.4 - 0.5', color: '#EFA782' },
      { to: Infinity, label: '0.5 - 0.6', color: '#BF9381' },
    ],
  },
  exposurePopulation: {
    property: 'POP_EXPP',
    label: 'Exposure population',
    stops: [
      { to: 20, label: '0 - 20', color: '#F7FCF5' },
      { to: 50, label: '20 - 50', color: '#C9EAC2' },
      { to: 90, label: '50 - 90', color: '#7BC77C' },
      { to: 95, label: '90 - 95', color: '#2A924B' },
      { to: Infinity, label: '95 - 100', color: '#00441B' },
    ],
  },
  exposureDwellings: {
    property: 'DW_EXPP',
    label: 'Exposure dwellings',
    stops: [
      { to: 20, label: '0 - 20', color: '#F7FCF5' },
      { to: 50, label: '20 - 50', color: '#C9EAC2' },
      { to: 90, label: '50 - 90', color: '#7BC77C' },
      { to: 95, label: '90 - 95', color: '#2A924B' },
      { to: Infinity, label: '95 - 100', color: '#00441B' },
    ],
  },
};

const LAND_USE_CONFIG = {
  type: 'landuse',
  label: 'Coastal hazard zone',
  categories: [
    { code: 'AGR', label: 'Agriculture', color: '#FFFCAC' },
    { code: 'NAT', label: 'Natural area', color: '#A9E1A7' },
    { code: 'IND', label: 'Industries and transport', color: '#B99CBD' },
    { code: 'PORT', label: 'Port and critical infrastructure', color: '#C0C0C0' },
    { code: 'REC', label: 'Tourism, recreation and open space', color: '#F5C57D' },
    { code: 'URB', label: 'Urban / residential', color: '#DD8889' },
    { code: 'WAT', label: 'Wetlands and water', color: '#9AC1DF' },
  ],
};

const LAYER_ORDER = ['risk', 'coastalHazardZone', 'exposurePopulation', 'exposureDwellings', 'vulnerability'];

function getFeatureColor(value, stops) {
  for (const stop of stops) {
    if (value <= stop.to) return stop.color;
  }
  return stops[stops.length - 1].color;
}

function getLayerConfig(key) {
  if (key === 'coastalHazardZone') return LAND_USE_CONFIG;
  return COMMUNITIES_LAYERS[key] || null;
}

export { COMMUNITIES_LAYERS, LAND_USE_CONFIG, LAYER_ORDER, getFeatureColor, getLayerConfig };
